<template>
  <div class="room-table">
    <el-table
      :data="props.room"
      style="width: 100%"
      height="360"
      size="small"
      :cell-class-name="cellGrayWhite"
    >
      <el-table-column
        prop="recordTime"
        label="Date"
        min-width="120"
        align="left"
      >
        <template #default="scope">
          <span v-if="scope.row.recordTime === null">-</span>
          <!--eslint-disable -->
          <span
            v-if="
              convertDate(scope.row.recordTime) === convertDate(new Date())
            "
          >
            Today
          </span>
          <span v-if="convertDate(scope.row.recordTime) === getPreviousDay()">
            Yesterday
          </span>
          <span
            v-if="
              scope.row.recordTime !== null &&
              convertDate(scope.row.recordTime) !== convertDate(new Date()) &&
              convertDate(scope.row.recordTime) !== getPreviousDay()
            "
            v-formatter="{
              data: scope.row.recordTime,
              formatter: 'YYYY/MM/DD',
              type: 'date',
            }"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="totalCount"
        label="Total Count"
        min-width="100"
        align="left"
      />
    </el-table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { convertDate } from '@/utils/util'
import { cellGrayWhite } from '@/utils/style'
import moment from "moment";

const props = defineProps({
  room: {
    type: Array,
    default: () => [],
  },
})

function getPreviousDay(date = new Date()) {
  return convertDate(moment(date).add(-1, 'days'));
}
</script>

<style scoped>
.room-table {
  width: 100%;
}
</style>
